import { IGetClienteByIdUseCase } from "../../../presentation/useCases/read/get_cliente_by_id_use_case";
import { Cliente } from "../../models/cliente";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * getClienteByIdUseCase
 */

export class GetClienteByIdUseCase implements IGetClienteByIdUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(idCliente: number): Promise<Cliente> {
    const result = await this.repository.getClienteById(idCliente);
    return result;

  }

}
